import React from 'react'

import './no-results-row.scss';

const NoResultsRow = () => {
    return (
        <tr className='no-results-row'>
            <td className='no-results-text'>NO RESULTS FOUND</td>
        </tr>
    )
}

export default NoResultsRow;
